import { Card, CardContent } from "@/components/ui/card";
import { Home, TrendingUp, Sun, Mountain } from "lucide-react";
import { useScrollAnimation, fadeInUp, staggerContainer, AnimatedDiv, AnimatedH2, AnimatedP } from "@/hooks/useScrollAnimation";

const Services = () => {
  const { ref, controls } = useScrollAnimation();
  
  const services = [
    {
      icon: Home,
      title: "Desert Living",
      description: "Discover stunning homes with red rock views, from modern estates to cozy retreats in St. George's finest communities."
    },
    {
      icon: Mountain,
      title: "Outdoor Paradise",
      description: "Minutes from Zion National Park, Snow Canyon, and world-class golf courses. Adventure awaits at your doorstep."
    },
    {
      icon: Sun,
      title: "300+ Sunny Days",
      description: "Enjoy year-round sunshine and mild winters in Utah's Dixie. The perfect climate for active living."
    },
    {
      icon: TrendingUp,
      title: "Growing Market",
      description: "St. George is one of America's fastest-growing cities. Smart investment in a thriving community."
    }
  ];

  return (
    <section className="py-12 md:py-20 bg-muted">
      <div className="container mx-auto px-4 md:px-6">
        <AnimatedDiv 
          ref={ref}
          initial="hidden"
          animate={controls}
          variants={fadeInUp}
          className="text-center mb-10 md:mb-16"
        >
          <AnimatedH2 
            variants={fadeInUp}
            className="text-2xl sm:text-3xl md:text-5xl heading-luxury text-brand-charcoal mb-4 md:mb-6"
          >
            WHY ST. GEORGE?
          </AnimatedH2>
          <AnimatedP 
            variants={fadeInUp}
            className="text-base md:text-lg text-luxury text-muted-foreground max-w-2xl mx-auto px-4"
          >
            Southern Utah's premier destination for luxury living, outdoor adventure, and unmatched natural beauty
          </AnimatedP>
        </AnimatedDiv>

        <AnimatedDiv 
          initial="hidden"
          animate={controls}
          variants={staggerContainer}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8"
        >
          {services.map((service, index) => (
            <AnimatedDiv key={index} variants={fadeInUp} className="h-full">
              <Card 
                className="property-card text-center group hover:shadow-xl bg-white border-0 shadow-md h-full transition-all duration-300"
              >
              <CardContent className="p-8 flex flex-col h-full">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-6 group-hover:bg-primary/20 transition-colors duration-300">
                  <service.icon className="w-8 h-8 text-primary" />
                </div>
                
                <h3 className="text-xl heading-luxury text-brand-charcoal mb-4">
                  {service.title}
                </h3>
                
                <p className="text-muted-foreground text-luxury leading-relaxed flex-grow">
                  {service.description}
                </p>
              </CardContent>
              </Card>
            </AnimatedDiv>
          ))}
        </AnimatedDiv>
      </div>
    </section>
  );
};

export default Services;